import { toast } from 'react-toastify';
import s from '../allservices.jsx';
import { getClientId, getClientSecret,buildClientHeader } from "../../utils/clientAuth.js"
const getCardNoDetailService = (actionCallback, cardNo, toggler) => {
let plink =  localStorage.getItem('pform')==='AU'? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ 
    let data = {
        applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
        cardNumber: cardNo
    }
    let token = "Token " + localStorage.getItem('token')
     let traceId = getClientId();
    fetch(plink + s.card_detail_by_cardno_service, {
            method: 'post',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': token,
                 'X-Trace-Id': traceId,
                 'X-KlickEx-Client':buildClientHeader(),
            }),
            body: JSON.stringify(data)
        })
        .then(res => {
            if (res.status === 200) {
                if (localStorage.getItem('cardNoToast') === 'first') {
                    toast.success(res.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 2000,
                        newestOnTop: true,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });
                    localStorage.setItem('cardNoToast', 'second')
                }

                res.json().then(json => actionCallback(json, "success"))
            } else if (res.status === 401) {
                actionCallback("401", "sessionout")
            } else if (res.status === 204) {
                toggler(res.headers.get('message'))
                actionCallback("204", "no-data")
            } else {
                toast.error(res.headers.get('message'), {
                    position: "top-right",
                    draggablePercent: 60,
                    autoClose: 2000,
                    newestOnTop: true,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false
                });
                actionCallback("no body", "error")
            }
        })
}

export default getCardNoDetailService;


// WEBPACK FOOTER //
// ./src/services/components/card_no_service.js